export default __webpack_public_path__ + "static/media/13244073_1277572828922843_1571284068826816752_o-removebg-preview (1).8b03fbe0.png";